// The terms the proposal adds to the deal as the deal's page lists them (TX-US-0043), each a label
// and the words for its value, empty where nothing was entered. Shared by the page's field list
// and by Proposal's view of what it holds once the deal has passed it.

import { incotermOf, namedPlaceLabel } from './vocabulary.js';

const labelIn = (entries, code) => entries.find((entry) => entry.code === code)?.label ?? code;

// The words for the codes the terms store, from the lists useReferenceLists reads: payment terms
// from their reference list, origin and destination from the location register. A code with no
// entry is shown as it is.
export const termLabels = (lists) => ({
  paymentTerm: (code) => labelIn(lists.payment_terms, code),
  location: (code) => labelIn(lists.locations, code),
});

const period = (range) => (range ? `${range.start ?? '…'} to ${range.end ?? '…'}` : '');

export function dealTerms(fields, labels, vocabulary) {
  const term = incotermOf(vocabulary, fields.incoterms);
  const tolerance = fields.quantity_tolerance_pct;
  return [
    ['Incoterm', fields.incoterms ? [fields.incoterms, term?.name].filter(Boolean).join(' - ') : ''],
    ['Risk passes', term?.risk_passes ?? ''],
    ["Seller's costs end", term?.costs_end ?? ''],
    [namedPlaceLabel(vocabulary, fields.incoterms), fields.named_place ?? ''],
    ['Quantity tolerance', tolerance !== null && tolerance !== undefined ? `±${tolerance}%` : ''],
    ['Origin', fields.origin ? labels.location(fields.origin) : ''],
    ['Destination', fields.destination ? labels.location(fields.destination) : ''],
    ['Delivery period', period(fields.delivery_period)],
    ['Payment terms', fields.payment_terms ? labels.paymentTerm(fields.payment_terms) : ''],
    ['Logistics', fields.logistics ?? ''],
  ];
}
